const mealCategoryOptions = [
  { key: "breakfast", label: "Breakfast" },
  { key: "lunch", label: "Lunch" },
  { key: "dinner", label: "Dinner" },
  { key: "snack", label: "Snack" },
];

export function UserMealFormMealCategory({ form, toggleMealCategory }) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6">
      <label className="block text-sm font-medium text-gray-900 mb-2">
        Meal Type
      </label>
      <p className="text-sm text-gray-500 mb-4">
        Select when this meal is typically eaten.
      </p>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {mealCategoryOptions.map(({ key, label }) => {
          const isSelected = form.mealCategories[key];

          return (
            <button
              key={key}
              type="button"
              onClick={() => toggleMealCategory(key)}
              className={`
                px-3 py-2.5 rounded-lg text-sm font-medium border transition-all
                ${
                  isSelected
                    ? "bg-gray-900 text-white border-gray-900"
                    : "bg-white text-gray-700 border-gray-200 hover:bg-gray-50"
                }
              `}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
